import "./App.css";
import "./assets/Styles/style.css";

import "bootstrap/dist/css/bootstrap.min.css";
import Demo from "./pages/Demo";
import {
  Route,
  RouterProvider,
  createBrowserRouter,
  createRoutesFromElements,
} from "react-router-dom";

import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.min.css";
import { useDispatch, useSelector } from "react-redux";
import LandingPage, { loader as landingPageLoader } from "./pages/Landing";
import Card1Page from "./pages/Card1Page/Card1Page";
import About from "./pages/About";
import DetailForm from "./pages/DetailForm";
import CardCollection from "./pages/CardCollection";
import Template from "./pages/Template";
import Card2Page from "./pages/Card2Page/Card2Page";
import ContactUsPage, {
  action as submitContactFormAction,
} from "./pages/ContactUsPage/ContactUsPage";
import ErrorElement from "./stories/ErrorElement/ErrorElement";
import MyCards from "./pages/MyCards/MyCards";
import CardsPage from "./pages/CardsPage/CardsPage";
import CheckoutPage from "./pages/CheckoutPage/CheckoutPage";
import { BaseURL, stripePublicKey } from "./config/apiUrl";
import { Get } from "./Axios/AxiosFunctions";
import { saveCardPrice, saveTags } from "./redux/common/commonSlice";
import { useEffect } from "react";

// stripe
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
import CardDetailPage from "./pages/CardDetailPage/CardDetailPage";
import { signOutRequest } from "./redux/auth/authSlice";
const stripePromise = loadStripe(stripePublicKey);

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route path="/" errorElement={<ErrorElement />}>
      <Route index element={<LandingPage />} />
      <Route path="/demo" element={<Demo />} />
      <Route path="/fire" element={<Card1Page />} />
      <Route path="/blaze" element={<Card2Page />} />
      <Route path="/about" element={<About />} />
      <Route path="/detail-form" element={<DetailForm />} />
      <Route path="/template" element={<Template />} />
      <Route path="/collections" element={<CardCollection />} />
      <Route path="/cardDetail/:id" element={<CardDetailPage />} />
      <Route
        path="/contact-us"
        element={<ContactUsPage />}
        action={submitContactFormAction}
      />

      <Route path="/my-cards" element={<MyCards />} />

      <Route path="/cards" element={<CardsPage />} />
      <Route
        path="/checkout"
        element={
          <Elements stripe={stripePromise}>
            <CheckoutPage />
          </Elements>
        }
      />
    </Route>
  )
);

function App() {
  const dispatch = useDispatch();
  const token = useSelector((state) => state?.authReducer?.access_token);
  const location = useSelector((state) => state?.commonReducer?.location);

  // getAppData
  const getAppData = async () => {
    const tagUrl = BaseURL("tags");
    const appUrl = BaseURL("app");
    const [tagResponse, appResponse] = await Promise.all([
      Get(tagUrl),
      Get(appUrl),
    ]);
    if (tagResponse !== undefined) dispatch(saveTags(tagResponse?.data?.data));
    if (appResponse !== undefined) {
      const cardPrice = appResponse?.data?.data?.find(
        (e) => e?.KeyType === "card-price"
      )?.price;
      dispatch(saveCardPrice(cardPrice));
    }
  };

  useEffect(() => {
    getAppData();
  }, []);

  // get me
  const getMe = async () => {
    const url = BaseURL("users/me");
    const response = await Get(url, token);
    if (response !== undefined) {
      if (response?.data?.data?.user?.isActive == false) {
        dispatch(signOutRequest());
        toast.error(
          "Your account has been suspended by admin. Kindly contact support for more information."
        );
      }
    }
  };

  useEffect(() => {
    token && getMe();
  }, [location?.pathname]);

  return (
    <>
      <ToastContainer />
      <RouterProvider router={router} />
    </>
  );
}

export default App;

/* <ProtectedRoute
            path="/CheckScreen"
            exact
            component={<CheckScreen />}
          /> */
